import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemHelperPermissionRoute: InvariantJiraRoute = {
	name: 'global-settings-system-helper-permission',
	path: '/secure/admin/PermissionHelperAdmin.jspa',
};
